// extracted by mini-css-extract-plugin
module.exports = {"mainTokensDiv":"Tokens_mainTokensDiv__1xHBW"};